import { Divider } from '@nextui-org/react';
import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';
import Link from '../Link';
import { ShimmerText } from '../Shimmer';

export const TabsInnerContainer = styled.div`
  overflow-x: auto;
  position: relative;
  width: 100%;
  flex-wrap: nowrap;
  display: flex;

  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
    height: 0px;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

interface TabProps {
  $paddingBottom?: string;
  $marginRight?: string;
  $disabled: boolean;
}

export const Tab = styled(Link).attrs((props) => {
  const isActive = props.status === 'active';
  const color = props.$disabled ? '$disabledText' : isActive ? props.theme.colors.primary.c500 : '$grayScaleText';
  return {
    ...props,
    css: {
      ...props.css,
      '&': {
        ...props.css?.['&'],
        color,
        borderBottom: isActive ? `2px solid ${props.theme.colors.primary.c500 as string}` : '2px solid transparent',
        marginRight: props.$marginRight || '1.5rem',
        zIndex: '2',
        whiteSpace: 'nowrap',
        stroke: color,
      },
    },
  };
})<TabProps>`
  pointer-events: ${(props: TabProps) => (props.$disabled ? 'none' : 'auto')};
  padding-bottom: ${(props: TabProps) => props.$paddingBottom || '1rem'};
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding-bottom: ${(props: TabProps) => props.$paddingBottom || '0.5rem'};
  }
  svg {
    margin: auto 0.5rem auto 0;
  }
`;

export const Title = styled.div`
  margin: auto 0;
`;

export const ScrollHint = styled.div`
  position: absolute;
  bottom: 2px;
  right: 0;
  width: 1.5rem;
  height: 100%;
  z-index: 4;
  background: linear-gradient(270deg, #f9f9fe 26.37%, rgba(249, 249, 254, 0) 100%);

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const StyledDivider = styled(Divider)`
  margin-top: -1px;
`;

export const PageContainer = styled.div`
  width: 100%;
  padding: 2rem 5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 1rem;
  }
`;

export const StyledShimmer = styled(ShimmerText).attrs(() => {
  return { width: '6rem', height: '1rem' };
})<TabProps>`
  && {
    margin-right: ${(props: TabProps) => props.$marginRight || '1.5rem'};
    &.shimmer-title {
      margin-bottom: ${(props: TabProps) => props.$paddingBottom || '1rem'} !important;
      @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
        margin-bottom: ${(props: TabProps) => props.$paddingBottom || '0.5rem'} !important;
      }
    }
    padding-bottom: 2px;
  }
`;
